const API_BASE = process.env.REACT_APP_API_BASE_URL;

const scheduleBasedRequest = {
	// --- Schedule endpoints ---

	async getScheduleById(scheduleId) {
		const res = await fetch(`${API_BASE}/schedules/${scheduleId}`, {
			method: "GET",
			headers: { "Content-Type": "application/json" },
		});

		if (!res.ok) throw new Error("Failed to fetch schedule");
		return res.json();
	},

	async createSchedule(scheduleData) {
		const res = await fetch(`${API_BASE}/schedules`, {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(scheduleData),
		});

		if (!res.ok) throw new Error("Failed to create schedule");
		return res.json();
	},

	async createBooking(bookingData, token) {
		const res = await fetch(`${API_BASE}/bookings`, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				// ...(token ? { Authorization: `Bearer ${token}` } : {}),
			},
			body: JSON.stringify(bookingData),
		});

		if (!res.ok) throw new Error("Failed to create booking");
		return res.json();
	},

	async updateSchedule(scheduleId, updates, token) {
		const res = await fetch(`${API_BASE}/schedules/${scheduleId}`, {
			method: "PUT",
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${token}`, // ✅ send Cognito AccessToken
			},
			body: JSON.stringify(updates),
		});

		if (!res.ok) {
			const err = await res.json().catch(() => ({}));
			throw new Error(err.error || "Failed to update schedule");
		}

		return res.json();
	},

	// --- Availability endpoints ---

	async getstaffAvailability(scheduleId, { date, duration, interval }) {
		const params = new URLSearchParams({ date, duration, interval });
		const res = await fetch(`${API_BASE}/schedreaules/${scheduleId}/availability?${params}`, {
			method: "GET",
			headers: { "Content-Type": "application/json" },
		});

		if (!res.ok) throw new Error("Failed to fetch staff availability");
		return res.json();
	},

	async getAvailability(id, { startDate, duration, interval, autoAssign } = {}) {
		const params = new URLSearchParams();

		if (startDate) params.append("startDate", startDate);
		if (duration) params.append("duration", duration);
		if (interval) params.append("interval", interval);
		if (autoAssign) params.append("autoAssign", autoAssign);

		const res = await fetch(`${API_BASE}/availability/${id}?${params.toString()}`, {
			method: "GET",
			headers: { "Content-Type": "application/json" },
		});

		if (!res.ok) throw new Error("Failed to fetch availability");
		return res.json();
	},

	async cancelBooking(bookingId, token) {
		const headers = { "Content-Type": "application/json" };
		if (token) headers.Authorization = `Bearer ${token}`; // only add if logged in

		const res = await fetch(`${API_BASE}/bookings/${bookingId}/cancel`, {
			method: "DELETE",
			headers,
		});

		if (!res.ok) throw new Error("Failed to cancel booking");
		return res.json();
	},

	async rescheduleBooking(bookingId, data, token) {
		const headers = { "Content-Type": "application/json" };
		if (token) headers.Authorization = `Bearer ${token}`; // only add if logged in

		const res = await fetch(`${API_BASE}/bookings/${bookingId}/reschedule`, {
			method: "PUT",
			headers,
			body: JSON.stringify(data),
		});

		if (!res.ok) throw new Error("Failed to reschedule booking");
		return res.json();
	},

	async addScheduleExclusion(scheduleId, exclusionData, token) {
		const res = await fetch(`${API_BASE}/schedule/${scheduleId}/add/exclusions`, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				Authorization: token ? `Bearer ${token}` : "", // ✅ Attach token if available
			},
			body: JSON.stringify(exclusionData),
		});

		if (!res.ok) {
			const errorText = await res.text();
			throw new Error(`Failed to add exclusion: ${errorText}`);
		}

		return res.json(); // { message, exclusion, updated }
	},

	async deleteScheduleExclusion(scheduleId, index, token) {
		const res = await fetch(`${API_BASE}/schedule/${scheduleId}/delete/exclusions`, {
			method: "DELETE",
			headers: {
				"Content-Type": "application/json",
				Authorization: token ? `Bearer ${token}` : "",
			},
			body: JSON.stringify({ index }), // ✅ send index to backend
		});

		if (!res.ok) {
			const errorText = await res.text();
			throw new Error(`Failed to delete exclusion: ${errorText}`);
		}

		return res.json(); // { message, updated }
	},
};

export default scheduleBasedRequest;
